// extracted by mini-css-extract-plugin
export var fullWidthButton = "_fx-0";